window.aboutUs = () => {
    return {
        activeTab: '1',
        setTab() {
            console.log('In');
            if (window.location.hash) {
                let hash = window.location.hash;

                this.activeTab = hash.replace('#tab=','');
            }
        }
    }
}
